import { render, staticRenderFns } from "./EditResearchGroup.html?vue&type=template&id=53061123&scoped=true&external"
import script from "./EditResearchGroup.vue?vue&type=script&lang=js"
export * from "./EditResearchGroup.vue?vue&type=script&lang=js"
import style0 from "./EditResearchGroup.scss?vue&type=style&index=0&id=53061123&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53061123",
  null
  
)

export default component.exports